<li class="list-group-item list-group-item-light mt-2">
  <div class="d-flex align-items-center mb-2 justify-content-between">
    <div>
      <h4 class="m-0">{{feeder.name}}</h4>
    </div>
    <div class="badge center ml-2">
      <b>{{validateTotalAlerts(feeder)}} / {{validateTotalClickAlert()}}</b>
    </div>
  </div>
  <ng-container *ngIf="!feeder.gateway_error  || feeder.gateway_error.length === 0; else NoGateway">
    <ng-container *ngFor="let type of types">
      <ul class="list-group" *ngIf="test[type] && test[type].length > 0 ">
        <ng-container
          *ngFor="let item of validateItemsArray(test[type], feeder, type);let i = index;"
        >
          <li [class]="setClass(item.nuevo.status)">
            <div class="row">
              <!-- Error: respuesta a la izquierda y reintento a la derecha en todas las resoluciones -->
              <ng-container *ngIf="item.nuevo.status === 'error'">
                <div class="col">
                  <p class="mb-0">
                    <b>{{'testing.response' | translate}}: </b>{{item.nuevo.label}}
                  </p>
                </div>
                <div class="col-auto d-flex align-items-center">
                  <button
                    class="btn btn-danger"
                    (click)="individualAction(type,item.nuevo.action,i)"
                  >
                    <em class="fa fa-retweet"></em>
                  </button>
                </div>
              </ng-container>

              <ng-container *ngIf="item.nuevo.status === 'success'">
                <div class="col">
                  <div [innerHTML]="validateText(type, feeder,item) | safeHtml"></div>
                </div>
              </ng-container>
            </div>
          </li>
        </ng-container>
      </ul>
      <ul class="list-group" *ngIf="showView[type]">
        <li>
          <app-loader-settings [type]="type" [feeder]="feeder"> </app-loader-settings>
        </li>
      </ul>
    </ng-container>
  </ng-container>

  <ng-template #NoGateway>
    <ng-container *ngIf="!feeder.condition && feeder.gateway_error.length > 0">
      <p class="text-danger" *ngFor="let item of feeder.gateway_error">{{item}}</p>
    </ng-container>
  </ng-template>
</li>
